// Employee reports (/employee-reports). Project, center and role names are
// stored values; the Excel file stays Turkish.
const employeeReports = {
  page: {
    title: 'Employee Reports',
    subtitle: 'Which project and center each employee works on, and in which role.',
  },
  actions: {
    excel: 'Download Table',
    excelHint: 'Download the listed assignments as Excel',
  },
  stats: {
    centers: 'Total Centers',
    centersShort: 'Centers',
    projects: 'Total Projects',
    projectsShort: 'Projects',
    workers: 'Total Employees',
    workersFiltered: 'Filtered Employees',
    workersShort: 'Employees',
    assignments: '{{count}} assignments',
  },
  toolbar: {
    search: 'Search by name…',
    searchShort: 'Search employees…',
    project: 'Project',
    allProjects: 'All projects',
    center: 'Center',
    allCenters: 'All centers',
  },
  columns: {
    name: 'Employee',
    center: 'Center',
    project: 'Project',
    role: 'Role',
    rate: 'Tariff',
    assignedAt: 'Assigned On',
  },
  table: {
    listLabel: 'Employee assignments',
    empty: 'No employees match the selected criteria.',
    rangeOf: 'of {{total}} assignments',
    ofTotal: 'out of {{total}} assignments',
    jump: 'Go to page',
  },
  panel: {
    label: 'Selected assignment',
    heading: 'Project assignment',
    visits: 'Show Visits',
    otherAssignments: 'Other assignments',
  },
  toast: {
    centersError: 'Error loading the center list!',
    projectsError: 'Error loading the project list!',
    noVisits: 'No visits found for this employee.',
    visitsError: 'Error loading the visits.',
    excelDone: 'Excel file downloaded successfully',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default employeeReports;
